<div class="pahe-header mt-4">
    <h3>{{pageTitle}} Posts</h3>

    <a href="#" class="reset-filter"><img src="assets/images/times-circle.svg" alt="close" class="mr-2"> Clear All</a>
</div>
<div class="filter-selection-box">
    <div class="row">
        <div class="col-xl-3 col-sm-6">
            <div class="fiter-box">
                <form #examForm="ngForm" (ngSubmit)="onFormSubmit(examForm.value)">
                    <div class="input-selected bg-white border-all box-shadow border-radius-10">
                        <div class="filter-icon icon-exam">
                        </div>
                        Exam Type
                        <span class="arrow-toggle"></span>
                    </div>
                    <div id="exam-type" class="input-options bg-white box-shadow border-all border-radius-10 d-none">
                        <div class="search-header px-3 pt-3">
                            <div class="input-group">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary ml-0" type="button" id="button-addon2"><img src="assets/images/search.svg" alt="search"></button>
                                </div>
                                <input type="text" id="input_exam" class="form-control" placeholder="Search Exams" aria-describedby="button-addon2">
                            </div>
                        </div>
                        <div class="option-list px-3 pt-3">
                            <ul *ngFor="let exam of exams">
                                <li>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="{{exam.main_category}}_{{exam.id}}" ngModel name="examRadio" class="custom-control-input" value="{{exam.id}}">
                                        <label class="custom-control-label" for="{{exam.main_category}}_{{exam.id}}">{{exam.main_category}} </label>
                                    </div>
                            </ul>
                        </div>
                        <div class="option-button">
                            <button class="btn btn-black">Save</button>
                            <button class="btn btn-link btn-link-color">Clear Filter</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6">
            <div class="fiter-box">
                <div class="input-selected bg-white border-all box-shadow border-radius-10">
                    <div class="filter-icon subject-wise">
                    </div>
                    Subject type
                    <span class="arrow-toggle"></span>
                </div>
                <div id="subject-type" class="input-options bg-white box-shadow border-all border-radius-10 d-none">
                    <div class="search-header px-3 pt-3">
                        <div class="input-group">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary ml-0" type="button" id="button-addon2"><img src="assets/images/search.svg" alt="search"></button>
                            </div>
                            <input type="text" id="input_subject" value="" class="form-control" placeholder="Search Subjects" aria-describedby="button-addon2">
                        </div>
                    </div>
                    <div class="option-list px-3 pt-3">
                        <ul *ngFor="let subject of subjects">
                            <li>
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="{{subject.section_name}}_{{subject.id}}" name="subjectRadio" class="custom-control-input" value={{subject.id}}>
                                    <label class="custom-control-label" for="{{subject.section_name}}_{{subject.id}}">{{subject.section_name}}</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="option-button">
                        <button class="btn btn-black">Save</button>
                        <button class="btn btn-link btn-link-color">Clear Filter</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6">
            <div class="fiter-box">
                <div class="input-selected bg-white border-all box-shadow border-radius-10">
                    <div class="filter-icon date-wise">
                    </div>
                    Select Date
                    <!-- <span class="arrow-toggle"></span> -->
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6">
            <div class="fiter-box">
                <div class="input-selected bg-white border-all box-shadow border-radius-10">
                    <div class="filter-icon answer-wise">
                    </div>
                    Answered
                    <span class="arrow-toggle"></span>
                </div>
                <div id="comment-type" class="input-options bg-white box-shadow border-all border-radius-10 d-none">

                    <div class="option-list px-3 pt-3">
                        <ul>
                            <li>
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="Answered" name="customRadio" class="custom-control-input">
                                    <label class="custom-control-label" for="Answered">Answered</label>
                                </div>
                            </li>
                            <li>
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="allanswer" name="customRadio" class="custom-control-input">
                                    <label class="custom-control-label" for="allanswer"> Unanswered </label>
                                </div>
                            </li>

                        </ul>
                    </div>
                    <div class="option-button">
                        <button class="btn btn-black">Save</button>
                        <button class="btn btn-link btn-link-color">Clear Filter</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>